module.exports = __webpack_public_path__ + "static/img/labour-8.66d9a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-8.png
// module id = r7v2
// module chunks = 1